export default "/_next/static/images/0745299706f19dc8e486ffee4823d2ad.png";